webpackJsonp([9],{

/***/ "O1O2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"acheivements":"acheivements__2q3kJ","headingWrapper":"headingWrapper__1R9I5","heading":"heading__3J7H4","mainDescription":"mainDescription__6XQYK"};

/***/ }),

/***/ "iY4Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/preact-redux/dist/preact-redux.esm.js
var preact_redux_esm = __webpack_require__("E/bI");

// EXTERNAL MODULE: ../node_modules/preact-router/match.js
var match = __webpack_require__("sw5u");
var match_default = /*#__PURE__*/__webpack_require__.n(match);

// EXTERNAL MODULE: ./components/articleItem/style.scss
var style = __webpack_require__("O1O2");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./components/articleItem/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var articleItem_ArticleItem = function (_Component) {
  _inherits(ArticleItem, _Component);

  function ArticleItem() {
    _classCallCheck(this, ArticleItem);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  ArticleItem.prototype.render = function render() {
    return Object(preact_min["h"])(
      "section",
      { "class": style_default.a.acheivements },
      Object(preact_min["h"])(
        "div",
        { className: style_default.a.headingWrapper },
        Object(preact_min["h"])(
          "h2",
          { "class": style_default.a.heading },
          this.props.title
        ),
        Object(preact_min["h"])(
          "p",
          { "class": style_default.a.mainDescription },
          this.props.description
        )
      ),
      this.props.children
    );
  };

  return ArticleItem;
}(preact_min["Component"]);


// EXTERNAL MODULE: ./components/sankey/index.js + 2 modules
var sankey = __webpack_require__("EY8H");

// EXTERNAL MODULE: ./shared/actions/searchActions.js
var searchActions = __webpack_require__("B37S");

// EXTERNAL MODULE: ./components/nestedDropList/actions/index.js
var actions = __webpack_require__("doLN");

// EXTERNAL MODULE: ./shared/actions/routerActions.js
var routerActions = __webpack_require__("Y9jh");

// EXTERNAL MODULE: ./routes/tmp_home_financial_component/style.css
var tmp_home_financial_component_style = __webpack_require__("pzkh");
var tmp_home_financial_component_style_default = /*#__PURE__*/__webpack_require__.n(tmp_home_financial_component_style);

// CONCATENATED MODULE: ../node_modules/babel-loader/lib??ref--0!./routes/tmp_home_financial_component/index.js


function tmp_home_financial_component__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function tmp_home_financial_component__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function tmp_home_financial_component__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable indent */
/* eslint-disable no-mixed-spaces-and-tabs */
/************************* Preact Files ************************/






/********************** Redux Action Files *********************/




/************************ Style files  *************************/


var _ref2 = Object(preact_min["h"])(articleItem_ArticleItem, {
  title: "Financial Flow",
  description: "Find out where UNRWA’s resources come from, where they go and how they are changing people’s lives."
});

var tmp_home_financial_component_Home = function (_Component) {
  tmp_home_financial_component__inherits(Home, _Component);

  function Home(props) {
    tmp_home_financial_component__classCallCheck(this, Home);

    var _this = tmp_home_financial_component__possibleConstructorReturn(this, _Component.call(this, props));

    _this.getSankeyYear = function (year) {
      _this.setState({ sankeyYear: year });
    };

    _this.getBugetType = function (type) {
      var bugetType = type ? "budget" : "expense";
      _this.setState({ bugetType: bugetType });
    };

    _this.state = {
      sankeyYear: _this.props.yearList.list[0],
      bugetType: "budget"
    };
    return _this;
  }

  Home.prototype.componentWillMount = function componentWillMount() {
    this.props.clearSearchCountryField();
    this.props.searchOperatingUnitsListData();
  };

  Home.prototype.componentDidMount = function componentDidMount() {
    this.props.onChangeRoute("UNRWA Transparency Portal");
    window.scrollTo(0, 0);
  };

  Home.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.mapData.yearTimeline.mapCurrentYear !== this.props.mapData.yearTimeline.mapCurrentYear) {
      this.props.searchOperatingUnitsListData();
    }
  };

  Home.prototype.componentWillUnmount = function componentWillUnmount() {
    this.props.clearSearchCountryField();
  };

  Home.prototype.render = function render(props, _ref) {
    var sankeyYear = _ref.sankeyYear,
        bugetType = _ref.bugetType;

    return Object(preact_min["h"])(
      "div",
      null,
      Object(preact_min["h"])(
        "div",
        { "class": tmp_home_financial_component_style_default.a.financial_flow },
        _ref2,
        Object(preact_min["h"])(sankey["a" /* default */], {
          getSankeyYear: this.getSankeyYear,
          getBugetType: this.getBugetType
        })
      )
    );
  };

  return Home;
}(preact_min["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    searchAllResult: state.searchAllResult,
    mapData: state.mapData,
    yearList: state.yearList
  };
};

var tmp_home_financial_component_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateSearchText: function updateSearchText(data) {
      return dispatch(Object(searchActions["d" /* updateSearchText */])(data));
    },
    searchOperatingUnitsListData: function searchOperatingUnitsListData(searchParam, key) {
      return dispatch(Object(actions["n" /* searchOperatingUnitsListData */])(searchParam, key));
    },
    clearSearchCountryField: function clearSearchCountryField() {
      return dispatch(Object(actions["m" /* clearSearchCountryField */])());
    },
    searchResult: function searchResult(searchParam, key) {
      return dispatch(Object(actions["o" /* searchResult */])(searchParam, key));
    },
    onChangeRoute: function onChangeRoute(title) {
      return dispatch(Object(routerActions["b" /* onChangeRoute */])(title));
    }
  };
};

/* harmony default export */ var tmp_home_financial_component = __webpack_exports__["default"] = (Object(preact_redux_esm["b" /* connect */])(mapStateToProps, tmp_home_financial_component_mapDispatchToProps)(tmp_home_financial_component_Home));

/***/ }),

/***/ "pzkh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"heading":"heading__1m3m4","sideBar":"sideBar__2TgWj","map":"map__2qD37","wrapper":"wrapper__1G8KD","sankey":"sankey__DQ_bh","makeImpact":"makeImpact__kfVkb","financial_flow":"financial_flow__2YyF_","mainDescription":"mainDescription__1wA2V"};

/***/ })

});


// WEBPACK FOOTER //
// route-tmp_home_financial_component.chunk.12f75.js